/**функция переделывает текст валют в иконки 
 * руб. -> ₽
*/
export const makeCurrencyIcon = (currency?: string): string => {
  if (!currency) return ''
  const currencyElement = currency.toLowerCase().trim()
  const currencyIcon: Record<string, string> = {
    'руб.': '₽',
    'rub': '₽',
    'usd': '$'
  }
  return currencyIcon[currencyElement] || currency
}
